import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoTasaLineaDTO } from '../Model/neoTasaLineaDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoTasaLinea';
@Injectable({
  providedIn: 'root',
})
export class TasaLineaService {
  constructor(private _http: HttpClient) {}

  saveTasaLinea(tasaLinea: NeoTasaLineaDTO[]): Observable<NeoTasaLineaDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<NeoTasaLineaDTO>(API_URL, tasaLinea, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getTasasLineaPorIdParametrizacion(
    idParametrizacionLinea
  ): Observable<NeoTasaLineaDTO[]> {
    return this._http.get<NeoTasaLineaDTO[]>(
      `${API_URL}/parametrizacion/${idParametrizacionLinea}`
    ).pipe(catchError(HandleHttpError));
  }
}
